export default {
    "PPT_VALIDATION": 'Single Mode is not allowed for chosen premium payment term',
    "MINIMUM_ANNUAL_PREMIUM": "Minimum Annual premium is 1206",
    "MINIMUM_HALF_YEARLY_PREMIUM": "Minimum Half-Yearly premium is 617",
    "MINIMUM_MONTHLY_PREMIUM": "Minimum Monthly premium is 106"
}